module.exports = __webpack_public_path__ + "img/Tunisia.60df55fc.svg";